const initialState = {
  active: false,
  content: {}
}

const PageReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'TOGGLE_PAGE':
      return Object.assign({}, {
        ...state,
        active: !state.active
      })
    case 'OPEN_PAGE':
      return Object.assign({}, {
        ...state,
        active: true
      })
    case 'CLOSE_PAGE':
      return Object.assign({}, {
        ...state,
        active: false
      })
    case 'UPDATE_PAGE_CONTENT':
      return Object.assign({}, {
        ...state,
        content: action.value
      })
    case 'CLEAR_PAGE':
      return Object.assign({}, {
        ...state,
        content: {}
      })
    default:
      return state
  }
}

export default PageReducer
